// A dropdown menu for selecting exercises that are 'lift' types.
// @flow
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as _ from 'underscore';
import SearchableDropDown from './SearchableDropDown';
import type { Suggestion } from './dropdown/constants';

export type ExerciseSelectionProps = {
    data: any,
    selectedId: number,
    onSelect: () => void,
    isFocused: boolean
};

export class ExerciseSelectionStandAlone extends PureComponent<
    ExerciseSelectionProps
> {
    static defaultProps = {
        selectedId: 0,
        onSelect: () => {},
        isFocused: true
    };

    getTransformedDataSet = () => {
        const { data: exercises, selectedId } = this.props;

        let lifts = _.filter(exercises, (exercise: any) => {
            return exercise.isLift;
        });

        let selected = null;

        let data: Array<Suggestion> = [];

        // Massage the data to adhere to the Suggestion API.
        for (let i = 0; i < lifts.length; i++) {
            const { id, title, icon } = lifts[i];

            if (id === selectedId) {
                selected = i;
            }

            data.push({
                id,
                text: title,
                image: icon
            });
        }

        return {
            data,
            selected
        };
    };

    render() {
        const { data, selected } = this.getTransformedDataSet();
        return (
            <div className="fixed-width-dropdown">
                <SearchableDropDown
                    data={data}
                    selected={data[selected]}
                    onSelect={this.props.onSelect}
                    isOpen={this.props.isFocused && selected === null}
                    key={`sdd_${data.length}`}
                    placeholder="Search Lifts"
                />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        data: state.library.exerciseRef
    };
};

export default connect(mapStateToProps)(ExerciseSelectionStandAlone);
